import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Delete places
 *
 * @private
 */
export const deletePlaces = createAsyncThunk<
  // Return type of the placeIds creator
  void,
  // First argument to the placeIds creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/place/delete', async (placeIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/place/delete', {
      category: 'rpc',
      type: 'rpc/place/delete',
      placeIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deletePlace}`,
      { tags: ['rpc', 'place'], info: placeIds },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Delete place failed`,
      error,
    })
  }
})
